import Component from "../../js/lib/component";
import Page from "../page/page"

const classList = {
  root: ".js-nav",
  link: ".js-nav-link",
  dropmenu: ".js-nav-dropmenu"
};

export default class Nav extends Component {
  events() {
    this.$.link.on("click", e => this.toggleSubMenu(e));
  }
  toggleSubMenu(e) {
    if (this.$.window.width() > Page.breakpoint.l) return;

    e.preventDefault();

    const $link = $(e.currentTarget);
    const $submenu = $link.siblings(this.$.dropmenu);

    $link.parent().toggleClass("is-open");
    $submenu.toggle();
  }
}

Component.mount(Nav, {
  name: "Nav",
  classList,
  state: {}
});
